import { useCallback } from 'react';
import { additionalPropsContext, useCustomizationParams } from '../../context/ViewerContext';
import styles from './DescriptionField.module.scss';
import { useTranslation } from 'react-i18next';

interface DescriptionFieldProps {
  descriptionFieldValue?: string | null;
}

export const DescriptionField = (props: DescriptionFieldProps) => {
  const { customizationParams } = useCustomizationParams();
  const [t] = useTranslation();
  const { additionalProps, setAdditionalProps } = additionalPropsContext();
  const handleDescriptionChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (customizationParams?.descriptionField) {
      setAdditionalProps({ ...additionalProps, descriptionFieldValue: e.target.value });
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <input
        onChange={handleDescriptionChange}
        defaultValue={props.descriptionFieldValue || ''}
        type='text'
        maxLength={250}
        placeholder={t('Enter a tag for this customization')}
      />
    </div>
  );
};
